import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
						<img
								src="./probat.png"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Probat SE</div>
							<div className="work-subtitle">
								Full Stack Developer
							</div>
							<div className="work-duration">April 2024 - Current</div>
						</div>
						<div className="work">
						<img
								src="./FraunhoferIPA.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Fraunhofer IPA</div>
							<div className="work-subtitle">
								Full Stack Developer
							</div>
							<div className="work-duration">April 2024 - March 2025</div>
						</div>

						<div className="work">
						<img
								src="./HFTStuttgart.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">HFT Stuttgart</div>
							<div className="work-subtitle">
							R.A in Full Stack Development
							</div>
							<div className="work-duration">April 2024 - Feb 2025</div>
						</div>

						<div className="work">
						<img
								src="./PolygonBoat.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Polygon Boat</div>
							<div className="work-subtitle">
								Full Stack Developer
							</div>
							<div className="work-duration">May 2022 - September 2023</div>
						</div>

						<div className="work">
						<img
								src="./HighRadius.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">High Radius</div>
							<div className="work-subtitle">
								Product and Engineering Intern
							</div>
							<div className="work-duration">Jan 2022 - April 2022</div>
						</div>
						<div className="work">
						<img
								src="./compactgyan.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Compact Gyan</div>
							<div className="work-subtitle">
								MERN Developer
							</div>
							<div className="work-duration">October 2021 - December 2021</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
